export default __webpack_public_path__ + "static/1080-4b6961e7170f68a23ae0f8f325f3b1dc.gif";